if (!customElements.get('read-more-text')) {
  customElements.define(
    'read-more-text',
    class ReadMoreText extends HTMLElement {
      connectedCallback() {
        this.clamp = this.querySelector('[data-read-more-clamp]');
        this.toggle = this.querySelector('[data-read-more-toggle]');
        if (!this.clamp || !this.toggle) return;

        this.update();

        this.toggle.addEventListener('click', () => {
          const expanded = this.classList.toggle('is-expanded');
          this.toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        });

        // Re-evaluate whether the toggle is needed when the layout changes.
        this._onResize = () => this.update();
        window.addEventListener('resize', this._onResize);
      }

      disconnectedCallback() {
        if (this._onResize) window.removeEventListener('resize', this._onResize);
      }

      // Hide the toggle when the collapsed content already fits (nothing to expand).
      update() {
        if (this.classList.contains('is-expanded')) return;
        const overflowing = this.clamp.scrollHeight - this.clamp.clientHeight > 1;
        this.toggle.hidden = !overflowing;
      }
    }
  );
}
